import { Variants } from 'framer-motion';

// Fade in with upward movement
export const fadeInUp: Variants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

// Fade in with left slide
export const fadeInLeft: Variants = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 }
};

// Fade in with right slide
export const fadeInRight: Variants = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 20 }
};

// Simple fade in
export const fadeIn: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 }
};

// Scale animation for cards
export const scaleIn: Variants = {
  initial: { opacity: 0, scale: 0.9 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.9 }
};

// Stagger container for children
export const staggerContainer: Variants = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};

// Fast stagger for grids
export const fastStaggerContainer: Variants = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1
    }
  }
};

// Pulse animation for status indicators
export const pulseAnimation: Variants = {
  initial: { scale: 1, opacity: 0.7 },
  animate: {
    scale: [1, 1.05, 1],
    opacity: [0.7, 1, 0.7],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }
};

// Hover scale effect
export const hoverScale = {
  whileHover: { 
    scale: 1.05,
    transition: { type: 'spring', stiffness: 400, damping: 17 }
  },
  whileTap: { scale: 0.95 }
};

// Glow effect on hover
export const glowHover = {
  whileHover: {
    boxShadow: '0 0 20px rgba(0, 217, 255, 0.5)',
    transition: { duration: 0.3 }
  }
};

// Float animation for background elements
export const floatAnimation = {
  animate: {
    y: [-10, 10, -10],
    transition: {
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }
};

// Rotate animation for decorative elements
export const rotateAnimation = {
  animate: {
    rotate: [0, 360],
    transition: {
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }
  }
};

// Default smooth transition
export const defaultTransition = {
  duration: 0.6,
  ease: [0.4, 0, 0.2, 1]
};

// Spring transition for interactive elements
export const springTransition = {
  type: 'spring' as const,
  stiffness: 400,
  damping: 17
};
